// extracted by mini-css-extract-plugin
export var attachment = "_sd-a";
export var emailContainer = "_sd-4";
export var emailContentPaddedContainer = "_sd-b";
export var emailHeader = "_sd-6";
export var emailIframe = "_sd-3";
export var emailInfoIcon = "_sd-9";
export var emailShortenedSummary = "_sd-e";
export var infoDropdown = "_sd-0";
export var infoRowBoundedContent = "_sd-d";
export var internal = "_sd-5";
export var merchant = "_sd-8";
export var messageInputContainer = "_sd-h";
export var normal = "_sd-7";
export var replyCard = "_sd-f";
export var subtleButton = "_sd-1";
export var subtleButtonIconContainer = "_sd-2";
export var toggleViewRepliesButton = "_sd-c";
export var wrappingText = "_sd-g";